import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { TopSpendBuyersQuery, TopSpendBuyersRequest } from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";

const topSpendBuyersQuery = graphql(`
  query topSpendBuyers($request: TopSpendBuyersRequest!) {
    topSpendBuyers(TopSpendBuyersRequest: $request) {
      totalResults
      results {
        buyerGuid
        buyerName
        totalValue
        transactionCount
      }
    }
  }
`);

/** One buyer's total spend + transaction count under the filter. */
export type TopSpendBuyer = TopSpendBuyersQuery["topSpendBuyers"]["results"][number];

/**
 * Top buyers by spend, plus the distinct-buyer total. Powers the buyer rankings
 * table and the buyer chart's top-10 series.
 */
export function useTopSpendBuyers(
  request: TopSpendBuyersRequest,
  options?: UseQueryOptions<TopSpendBuyersQuery, unknown, TopSpendBuyersQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery(
    ["topSpendBuyers", request],
    topSpendBuyersQuery,
    [{ request }],
    options,
  );

  return { data: data?.topSpendBuyers, ...rest };
}
